import { HISTORY_PATH } from './historyFormat';

// The Today tile's wording and links. Types are data (a stored name): a label from the language files when there is one, otherwise the stored name made readable.

const humanize = (s) => { const x = String(s || '').replace(/_/g, ' ').trim(); return x ? x.charAt(0).toUpperCase() + x.slice(1) : '—'; };

export function typeLabel(t, prefix, type) {
  const key = `${prefix}${type}`;
  const text = t(key);
  return text && text !== key ? text : humanize(type);
}
export const docLabel = (t, type) => typeLabel(t, 'today.doc.', type);
export const problemLabel = (t, type) => typeLabel(t, 'today.problem.', type);

// The History filter that matches a stored document type (History has four): the others open History for the day without a type.
const HISTORY_KIND = { purchase_order: 'order', invoice: 'invoice', delivery_note: 'delivery_note', packing_list: 'packing_list', packing_slip: 'packing_list' };

// A Received row opens History from today on (in the router state, never in the address), filtered to the type where History has one.
export const receivedLink = (type, today) => ({ to: HISTORY_PATH, state: { since: today, ...(HISTORY_KIND[type] ? { type: HISTORY_KIND[type] } : null) } });
export const unclassifiedLink = () => ({ to: HISTORY_PATH, state: { tab: 'unclassified' } });
export const discrepancyPath = (type) => `/cases/new-today/by-type/${encodeURIComponent(type)}`;
